export default __webpack_public_path__ + "static/media/very_happy.817ef69b.png";